import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    flex-wrap: nowrap;
    overflow: hidden;
    position: relative;
`;

export const EmptyItems = styled.div`
    color: #fff;
    position: relative;
    height: 100%;
    width: 100%;
    text-align: center;
    padding-top: 70px;
    color: #666;

    :before {
        content: '\\F04E5';
        font-family: "Material Design Icons";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 50px;
        height: 50px;
        margin-top: -45px;
        margin-left: -25px;
        color: #444;
        font-size: 50px;
        line-height: 50px;
        text-align: center;
    }
`;

export const ItemName = styled.div`
    color: #fff;
    text-shadow: -2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000, 2px -2px 0 #000;
    text-align: center;
`;

export const ItemValue = styled.div`
    color: #fff;
    text-shadow: -2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000, 2px -2px 0 #000;
`;

export const PreviousItems = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: calc(50% + 30px);
    bottom: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden;
`;

export const NextItems = styled.div`
    position: absolute;
    top: 0;
    left: calc(50% + 30px);
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden;
`;

export const Item = styled.div`
    height: 100%;
    width: 80px;
    min-width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    transform-origin: 50% 0;

    ${PreviousItems} & ${ItemName},
    ${PreviousItems} & ${ItemValue},
    ${NextItems} & ${ItemName},
    ${NextItems} & ${ItemValue} {
        color: #999;
    }

    ${PreviousItems} &:nth-child(1),
    ${NextItems} &:nth-child(1) {
        margin: 6px -16px 0;
        transform: scale(0.85);
        filter: brightness(0.85);
        z-index: 3;
    }

    &:nth-child(2) {
        margin: 12px -22px 0;
        transform: scale(0.7);
        filter: brightness(0.7);
        z-index: 2;
    }
    &:nth-child(3) {
        margin: 18px -28px 0;
        transform: scale(0.55);
        filter: brightness(0.55);
        z-index: 1;
    }
`;

export const CurrentItem = styled.div`
    position: absolute;
    top: 0;
    left: calc(50% - 40px);
    bottom: 0;
    width: 80px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden;
    z-index: 3;

    }

    & ${ItemName} {
        color: #fc2;
    }
    & ${ItemValue} {
        color: #fc2;
    }
`;

export const ItemImage = styled.div`
    width: 80px;
    height: 80px;
    position: relative;
    margin-bottom: 5px;
    border-radius: 50%;
    overflow: hidden;
`;

export const EmptyImage = styled.div`
    background-color: #666;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    &:before {
        content: '?';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #333;
        font-size: 40px;
        font-weight: 900;
    }
`;

